import { Link } from 'react-router-dom';
import { ChefHat, Facebook, Instagram, Twitter, Youtube, Mail } from 'lucide-react';
import styles from './Footer.module.css'
import ft from '../assets/ft.png'
import { useTranslate } from './UseTranslate';
import { getCategoriesApi } from '../http/api';
import { useSelector } from 'react-redux';
import { useState,useEffect } from 'react';
import axios from 'axios';

export function Footer() {


  const {t} = useTranslate();

  const [categories,setCategories] = useState([])


  const {language} = useSelector((state)=>state.language)



   const fetchCategories=async()=> {
    // setLoading(true);
    try{
      const response = await axios.get(getCategoriesApi(language));
      console.log(response.data,"categories");
      setCategories(response?.data?.categories);
      // setCategory(response?.data?.categories?.find((cat) => cat.id == categoryId));
    }
    catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
  fetchCategories();
}, [language]);



  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
         {/* <img className={styles.ftimg} src={ft} alt='img' /> */}
        <div className={styles.grid}>
          {/* Brand */}
          <div className={styles.brandSection}>
            <Link to="/" className={styles.brandLink}>
              <ChefHat className={styles.brandIcon} />
              <span className={styles.brandName}>UVFood Box</span>
            </Link>
            <p className={styles.brandDesc}>
              {t('Discover, share, and create amazing recipes from around the world.')}
            </p>
            <div className={styles.socialIcons}>
              <a href="#" className={styles.socialLink}><Facebook className={styles.socialIcon} /></a>
              <a href="#" className={styles.socialLink}><Instagram className={styles.socialIcon} /></a>
              <a href="#" className={styles.socialLink}><Twitter className={styles.socialIcon} /></a>
              <a href="#" className={styles.socialLink}><Youtube className={styles.socialIcon} /></a>
            </div>

          </div>

          {/* Quick Links */}
          <div>
            <h3 className={styles.heading}>Quick Links</h3>
            <ul className={styles.list}>
              <li><Link to="/" className={styles.link}>{t('Home')}</Link></li>
              <li><Link to="/about" className={styles.link}>{t('About Us')}</Link></li>
              <li><Link to="/add-recipe" className={styles.link}>{t('Submit Recipe')}</Link></li>
              <li><Link to="/profile" className={styles.link}>{t('My Profile')}</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className={styles.heading}>{t('Categories')}</h3>
        <ul className={styles.list}>
  {categories.slice(0, 4).map((category) => (
    <li key={category.id}>
      <Link
        to={`/category/${category.id}`}
        className={styles.link}
      >
        {category.category_name}
      </Link>
    </li>
  ))}
</ul>
          </div>

          {/* Newsletter */}
          {/* <div>
            <h3 className={styles.heading}>Newsletter</h3>
            <p className={styles.newsDesc}>
              Subscribe to get weekly recipes and cooking tips.
            </p>
            <form className={styles.newsForm}>
              <div className={styles.inputWrapper}>
                <input
                  type="email"
                  placeholder="Your email"
                  className={styles.inputField}
                />
                <Mail className={styles.inputIcon} />
              </div>
              <button type="submit" className={styles.submitBtn}>
                Subscribe
              </button>
            </form>
          </div> */}
        </div>

        <div className={styles.copyright}>
          <p>&copy; 2026 UVFOOD BOX. {t('All rights reserved')}.</p>
          <span className={styles.comp}>UVCANN Solutions LLP </span>
        </div>
      </div>

        <div className={styles.steamContainer}>
    <span className={styles.steam}></span>
    <span className={styles.steam}></span>
    <span className={styles.steam}></span>
    <span className={styles.steam}></span>
  </div>
    </footer>
  );
}